import styled from 'styled-components';
import ds from '../../../utils/designSystem';

export const Main = styled.div`
  align-items: center;
  border-bottom: 1px solid #666;
  padding: 20px;
`;

export const DatesContainer = styled.div`
  flex: 1;
  display: flex;
  padding: 15px;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  width: 80%;
`;

export const Button = styled.button`
  background: #0083ff;
  color: white;
  cursor: pointer;
  font-size: 14px;
  border-radius: 4px;
  border: none;
  height: 30px;
  padding: 0 20px;
  transition: opacity 0.3s;
  &:active {
    opacity: 0.6;
    transform: translateY(1px);
  }
`;

export const Send = styled.div`
  display: flex;
  justify-content: space-evenly;
  flex-direction: row;
  align-items: center;
  font-family: ${ds.fontFamily.main};
`;
